import React from 'react';
import { Route, Redirect, useLocation, RouteProps } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useServerData } from '@xingternal/hops';
import { getLoginUrl } from '@/utils/url';

const AuthenticatedRoute: React.FC<RouteProps> = ({
  render,
  ...routeProps
}) => {
  const { authenticated } = useServerData();
  let location = useLocation();

  return authenticated ? (
    <Route {...routeProps} render={render} />
  ) : (
    <Redirect to={getLoginUrl({ location: location.pathname })} />
  );
};

AuthenticatedRoute.propTypes = {
  render: PropTypes.func.isRequired,
};

export default AuthenticatedRoute;
